'use strict';

var getDateParamKey = require('./getDateParamKey'),
    coreUtilityAliases = require('../../common/var/coreUtilityAliases');

var getOwn = coreUtilityAliases.getOwn;

function getDateParam(params, key) {
  return getOwn(params, getDateParamKey(params, key));
}

module.exports = getDateParam;


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/date/internal/getDateParam.js
// module id = 209
// module chunks = 1